// extracted by mini-css-extract-plugin
export default {"miniPaintingItem":"miniPaintingItem_miniPaintingItem__9-hWa"};